import React, { useState, useEffect } from "react";
import StatsEllipse from "../assets/images/stats-section-elipse.svg";

const stats = [
  {
    count: "3,312",
    label: "Ventures supported",
    description:
      "Through funding, incubation, acceleration, mentorship, and market access programs across 49 countries.",
    color: "var(--red)",
  },
  {
    count: "1.89M",
    label: "People served in 2025",
    description: "Through CcHUB programs and the ventures we back.",
    color: "var(--green)",
  },
  {
    count: "$4.18M",
    label: "Deployed via grants and sub-grants",
    description:
      "Early-stage funding to ventures building solutions across the continent.",
    color: "var(--purple)",
  },
  {
    count: "544",
    label: "People landed new roles",
    description: "New careers started after gaining new skills",
    color: "var(--deep-blue)",
  },
];

const StatsSection: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % stats.length);
    }, 6500);
    return () => clearInterval(interval);
  }, []);

  const getPositionClass = (index: number) => {
    if (index === currentIndex) return "active";
    if (index === (currentIndex + 1) % stats.length) return "next";
    if (index === (currentIndex - 1 + stats.length) % stats.length)
      return "prev";
    return "back";
  };

  return (
    <section id="stats-section">
      <img src={StatsEllipse} alt="" className="stats-globe-ring" />
      <h2>
        2025 at <span className="red-highlight">a glance</span>
      </h2>

      <div className="stats-carousel">
        <div className="stats-display">
          <div className="stats-track">
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`stat-card ${getPositionClass(index)}`}
              >
                <div
                  className="stat-circle"
                  style={{ backgroundColor: stat.color }}
                >
                  <div className="stat-content">
                    <span className="stat-count">{stat.count}</span>
                    <span className="stat-label">{stat.label}</span>
                  </div>
                </div>
                <p className="stat-description">{stat.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="stats-indicators">
          {stats.map((_, index) => (
            <span
              key={index}
              className={`dot ${currentIndex === index ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
            ></span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
